"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Battery = void 0;
var react_1 = __importDefault(require("react"));
var Battery = function (props) { return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none" }, props, { viewBox: "0 0 20 20" }),
    react_1.default.createElement("g", { fill: "currentColor", clipPath: "url(#a)" },
        react_1.default.createElement("path", { d: "M14.695 2.55H6.39C5.588 2.626 5 3.181 5 3.735v15.058C5 19.455 5.748 20 6.656 20h7.8c.907 0 1.655-.545 1.655-1.206V3.736c-.027-.603-.64-1.09-1.416-1.187Zm-.854 8.51-4.247 4.865a.291.291 0 0 1-.187.058c-.027 0-.053 0-.08-.02-.08-.038-.134-.096-.107-.174l1.255-3.172-3.071-.097a.271.271 0 0 1-.16-.058c-.027-.04-.054-.078-.027-.117L9.14 7.227c.027-.058.107-.097.187-.097h3.392c.08 0 .134.02.16.059.027.038.054.097.027.136l-2.083 3.463 2.858.04a.19.19 0 0 1 .16.077.161.161 0 0 1 0 .156ZM13.868 1.712V.798c0-.448-.481-.798-1.095-.798H8.286C7.698 0 7.19.35 7.19.798v.914h6.678Z" })),
    react_1.default.createElement("defs", null,
        react_1.default.createElement("clipPath", { id: "a" },
            react_1.default.createElement("path", { fill: "currentColor", d: "M0 0h20v20H0z" }))))); };
exports.Battery = Battery;
